import { render, staticRenderFns } from "./cta-button.vue?vue&type=template&id=eb21f944&"
import script from "./cta-button.vue?vue&type=script&lang=js&"
export * from "./cta-button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports